module.exports = __webpack_public_path__ + "img/logo1.5b6c9173.png";